import { PeopleEmployeeLeaveDto } from "./employee/people-employee-leave.dto";
import { PeopleQueryBaseDto } from "./people-query-base.dto";

export class PeopleLeaveRequestStatusDto {
    id: number;
    name: string;
    createdDate?: Date;
    modifiedDate?: Date;
    lastModifiedUserId?: number;
    version?: number;

    employeeLeaves?: PeopleEmployeeLeaveDto[];
}

export interface PeopleLeaveRequestStatusQueryDto extends PeopleQueryBaseDto {
}